// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from "element-ui/src/locale/lang/en"
import './assets/common.less'
import dataV from '@jiaminghi/data-view'
import './until/flexible'
import echarts from 'echarts'
import VueI18n from "vue-i18n"
import zh from './lang/zh'
import en from './lang/en'
// import BaiduMap from 'vue-baidu-map'
import VueParticles from 'vue-particles'
import App from './App'
import router from './router'
Vue.prototype.$echarts = echarts;

Vue.use(dataV);
if(localStorage.getItem('locale') === 'en-US'){
  Vue.use(ElementUI,{locale});
} else {
  Vue.use(ElementUI);
}
Vue.use(VueI18n);
Vue.use(VueParticles);

// Vue.use(BaiduMap, {
//   ak: 'kdgbVvs8n1XdtPVl4cRiSoTsRMPjsZby'
// })

const i18n = new VueI18n({
  // locale:'zh-CN',
  locale: localStorage.getItem('locale'),
  messages: {
    'zh-CN': zh,
    'en-US': en
  },
  silentTranslationWarn: true
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js